$(function () {
  //Sliders
  $('.frame--testimonials').slick({
    dots: false,
    arrows: true,
    infinite: false,
    speed: 300,
    slidesToShow: 1,
    adaptiveHeight: true,
    autoplay: false,
    // appendArrows: $('.Testimonials-pagination'),
    // appendDots: $('.Testimonials-pagination'),
    autoplaySpeed: 5000
  });
});